import actionFromPromise from 'src/app/redux/utils/actionFromPromise';
import rest from './rest';

export default {
  // tslint:disable-next-line:object-literal-sort-keys
  submitFeedback: actionFromPromise(rest.submitFeedback)
};
